<ul *ngFor="let subList of subLists | sortByColumn">
    <li *ngFor="let subItem of subList.children" aria-level="2">
        <app-link *ngIf="!subItem.links?.length" [link]="subItem.columnHeading">
            <span class="button">
                {{ subItem.columnHeading.name }}
            </span>
        </app-link>
        <div appAccordionDirective [id]="subItem.id" *ngIf="subItem.links?.length">
            <button class="button {{ accordionClasses.Button }}">
                {{ subItem.columnHeading.name }}
                <span class="svg-wrapper">
                    <app-svg-icon iconName="chevron_down"></app-svg-icon>
                </span>
            </button>
            <div class="content {{ accordionClasses.Content }}">
                <span class="link-wrapper" *ngIf="subItem.columnHeading as heading">
                    <app-link [link]="heading">
                        {{ 'mobileMenu.seeAll' | translateSafe: { category: heading.name } }}
                    </app-link>
                </span>
                <span class="link-wrapper" *ngFor="let link of subItem.links">
                    <app-link [link]="link"></app-link>
                </span>
            </div>
        </div>
    </li>
</ul>
